import React from "react";

const NotFound = () => {
  return (
    <div className="not-found">
      <h1 className="mt-5 py-5">
        <span > 404</span> <br /> page not found
      </h1>
    </div>
  );
};

export default NotFound;
